module.exports = __webpack_public_path__ + "images/file_icons_v2/html-38e89aff4ab32d3390bdaeb89466cebd.svg";